import styled from "styled-components";
import { Row } from '../../styles';

export const StyledYesNoRow = styled(Row)`
  margin-top: 24px;
  margin-bottom: 24px;
`;